import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import './index.css';

const propTypes = {
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.arrayOf(PropTypes.element)])
    .isRequired,
  Icon: PropTypes.func.isRequired,
  iconFullOpacity: PropTypes.bool,
};

const defaultProps = {
  iconFullOpacity: false,
};

const IconTextInfo = ({ children, Icon, iconFullOpacity }) => {
  const renderText = () => {
    if (children.length) {
      return children.map(mapChildrenIntoTextLines);
    }

    return <div className="IconTextInfo__text_line">{children}</div>;
  };
  const mapChildrenIntoTextLines = (element, i) => {
    return (
      <div key={i} className="IconTextInfo__text_line">
        {element}
      </div>
    );
  };

  const componentClass = classNames('IconTextInfo__col', {
    'IconTextInfo__col--centered': !children.length,
  });

  const iconClass = classNames('IconTextInfo__icon', {
    'IconTextInfo__icon--full_opacity': iconFullOpacity,
  });

  return (
    <div className={componentClass}>
      <div>
        <Icon className={iconClass} />
      </div>
      <div className="IconTextInfo__text">{renderText()}</div>
    </div>
  );
};

IconTextInfo.propTypes = propTypes;
IconTextInfo.defaultProps = defaultProps;

export default IconTextInfo;



// WEBPACK FOOTER //
// ../ui-components/components/IconTextInfo/index.jsx